import React, { Component } from 'react';
// import Loading from 'react-loading-animation';
import { Link } from 'react-router';
import { connect } from 'react-redux';
// import Intercom from 'react-intercom';
import get from 'lodash/get'
import filter from 'lodash/filter'
import WebsiteCheckout from './WebsiteCheckout';
import WebsitePriceNew from './WebsitePriceNew';
// import './WebsitePayment.scss';
import { GET } from 'services/api';
import { CustomLoading } from 'components';
import {Background} from '../../img'
class WebsitePayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      planSelected: '',
      externalValue: true,
      planPeriod: 12,
      servicebotPlans: [],
      planClick: 'Advanced',
      coupon: '',
      monthlyPlans: [],
      yearlyPlans: []
      // intercomm: ''
    };
  }

  componentDidMount() {
    window.scrollTo(0,0);
        
    // if(this.props.user) {      
    //   this.setState({intercomm: {
    //     name: this.props.user.username, // Full name
    //     email: this.props.user.email, // Email address
    //     user_hash: localStorage.getItem('user_hash') // User hash
    //   }});
    // }
    var url_string = window.location.href
    var url = new URL(url_string);
    var calendlyStatus = url.searchParams.get("calendly");
    if(calendlyStatus){
      localStorage.setItem("calendly", "true")
    }

  }

  componentWillMount() {
    const queryPlan = this.props.location && this.props.location.query.plan;
    var that=this;
    GET('plan/chargebee').then(function(res){
      const PlanDataList = filter(get(res,'data'), obj=> get(obj,'product') !=='prod_Ej0I9T0yyoX4Kp')
      if (PlanDataList && get(PlanDataList,'length') > 0) {
        let lstPlan = [];
        for (var i = 0; i < PlanDataList.length; i++) {
          if(PlanDataList[i].active)
            lstPlan.push({
              // addon_applicability: 'all',
              // charge_model: 'flat_fee',
              currency: PlanDataList[i].currency,
              details: get(PlanDataList[i],'description'),
              // enabled_in_hosted_pages: PlanDataList[i].plan.enabled_in_hosted_pages,
              // enabled_in_portal: PlanDataList[i].plan.enabled_in_portal,
              free_quantity: 0,
              // giftable: PlanDataList[i].plan.giftable,
              id: PlanDataList[i].id,
              invoice_name: PlanDataList[i].nickname,
              // is_shippable: PlanDataList[i].plan.is_shippable,
              name: PlanDataList[i].nickname,
              object: PlanDataList[i].object,
              interval_count: PlanDataList[i].interval_count,
              interval: PlanDataList[i].interval,
              amount: PlanDataList[i].amount,
              // pricing_model: PlanDataList[i].plan.pricing_model,
              // resource_version: PlanDataList[i].plan.resource_version,
              status: PlanDataList[i].active,
              // taxable: PlanDataList[i].plan.taxable,
              description: Number(PlanDataList[i].metadata.uniquevisitorqouta),
              teammateQouta: Number(get(PlanDataList[i],'metadata.teammateqouta')||0),
              trial_period:PlanDataList[i].trial_period_days
            });
        }


        let selectedPlan, planClick, planPeriod;
        lstPlan = lstPlan.filter(plan => plan.name !== 'Agency');
        
        if(queryPlan && queryPlan.toLowerCase().indexOf('ltd')!==-1) {
          lstPlan = lstPlan.filter(plan => plan.name.toLowerCase().indexOf('lifetime')!==-1);    
          planPeriod = 0; 
        }
        else{
          lstPlan = lstPlan.filter(plan => plan.trial_period==7 || plan.amount==0);  
        }



        lstPlan.map(plan => {
          //console.log('===plan.id====',plan.id);
          if(plan.id == queryPlan && queryPlan != 2) {
            planClick = that.filterPlanName(plan.name);
            selectedPlan = plan;
          }

          if(plan.id == queryPlan && queryPlan && queryPlan.toLowerCase().indexOf('ltd')===-1)
            planPeriod = plan.interval == 'year' ? 
              12 
              : 
              plan.interval == 'month' && plan.interval_count == 6? 
                6
                : 
                1;                   
        });
        
        let monthsPlan = []
        monthsPlan = lstPlan.filter(plan=> plan.interval == 'month')
        monthsPlan.sort((a, b) => a.amount - b.amount)
      
        let yearPlans = []
        yearPlans = lstPlan.filter(plan=> plan.interval == 'year')
        yearPlans.sort((a, b) => a.amount - b.amount)
        
        //that.setState({servicebotPlans: lstPlan});
        that.setState({ servicebotPlans: lstPlan, selectedPlan: selectedPlan, planClick: planClick, planPeriod: planPeriod, monthlyPlans: monthsPlan, yearlyPlans:yearPlans });
        //console.log('============ lstPlan ===========',lstPlan,selectedPlan,planClick,planPeriod);
      }
    });

    // GET('plan/chargebee').then(function(res){
    //   if (res.list && res.list.length > 0) {
    //     let lstPlan = [];
    //     for (var i = 0; i < res.list.length; i++) {
    //       if(res.list[i].plan.status=='active')
    //         lstPlan.push({
    //           addon_applicability: res.list[i].plan.addon_applicability,
    //           charge_model: res.list[i].plan.charge_model,
    //           currency: res.list[i].plan.currency_code,
    //           details: res.list[i].plan.description,
    //           enabled_in_hosted_pages: res.list[i].plan.enabled_in_hosted_pages,
    //           enabled_in_portal: res.list[i].plan.enabled_in_portal,
    //           free_quantity: res.list[i].plan.free_quantity,
    //           giftable: res.list[i].plan.giftable,
    //           id: res.list[i].plan.id,
    //           invoice_name: res.list[i].plan.invoice_name,
    //           is_shippable: res.list[i].plan.is_shippable,
    //           name: res.list[i].plan.name,
    //           object: res.list[i].plan.object,
    //           interval_count: res.list[i].plan.period,
    //           interval: res.list[i].plan.period_unit,
    //           amount: res.list[i].plan.price,
    //           pricing_model: res.list[i].plan.pricing_model,
    //           resource_version: res.list[i].plan.resource_version,
    //           status: res.list[i].plan.status,
    //           taxable: res.list[i].plan.taxable,
    //           updated_at: res.list[i].plan.updated_at,
    //           description: res.list[i].plan.cf_uniquevisitorqouta,
    //           trial_period:res.list[i].plan.trial_period
    //         });
    //     }
    //     console.log('lstPlan*=*=*=*=*===*=*=>', lstPlan)

    //     let selectedPlan, planClick, planPeriod;
    //     lstPlan = lstPlan.filter(plan => plan.name !== 'Agency');
        
    //     if(queryPlan && queryPlan.toLowerCase().indexOf('ltd')!==-1) {
    //       lstPlan = lstPlan.filter(plan => plan.name.toLowerCase().indexOf('lifetime')!==-1);    
    //       planPeriod = 0; 
    //     }
    //     else{
    //       lstPlan = lstPlan.filter(plan => plan.trial_period==7 || plan.amount==0);  
    //     }

    //     lstPlan.map(plan => {
    //       //console.log('===plan.id====',plan.id);
    //       if(plan.id == queryPlan && queryPlan != 2) {
    //         planClick = that.filterPlanName(plan.name);
    //         selectedPlan = plan;
    //       }

    //       if(plan.id == queryPlan && queryPlan && queryPlan.toLowerCase().indexOf('ltd')===-1)
    //         planPeriod = plan.interval == 'year' ? 
    //           12 
    //           : 
    //           plan.interval == 'month' && plan.interval_count == 6? 
    //             6
    //             : 
    //             1;                   
    //     });
    //     console.log({selectedPlan, planClick, planPeriod});
    //     //that.setState({servicebotPlans: lstPlan});
    //     that.setState({ servicebotPlans: lstPlan, selectedPlan: selectedPlan, planClick: planClick, planPeriod: planPeriod });
    //     //console.log('============ lstPlan ===========',lstPlan,selectedPlan,planClick,planPeriod);
    //   }
    // });


  }

  handleChange = (checked) => {
    this.setState({checked});
  }

  handleMonthChange = () => {
    this.setState({externalValue: false, planPeriod: 1});
  }

  // handleQuaterlyChange = () => {
  //   this.setState({externalValue: false, planPeriod: 6});
  // }

  handleYearChange = () => {
    this.setState({externalValue: true, planPeriod: 12});
  }

  handleSwitchChange = (value) => {
    if (value) {
      this.setState({externalValue: true, planPeriod: 12});
    } else {
      this.setState({externalValue: false, planPeriod: 1});
    }
  }

  filterPlanName = (planName) => {
    let res='';

    switch(true) {
      case /\b(Enterprise)\b/m.test(planName) :  res=  'Enterprise' ; break;
      case /\b(Advanced)\b/m.test(planName) :  res=  'Advanced'; break;
      case /\b(Growth)\b/m.test(planName) :  res=  'Growth'; break;
      case /\b(Startups)\b/m.test(planName) : res=  'Startups'; break;
      case /\b(Lifetime Starter)\b/m.test(planName) : res= 'Starter'; break;
      case /\b(Lifetime Professional)\b/m.test(planName) : res= 'Professional'; break;
      case /\b(Lifetime Business)\b/m.test(planName) : res=  'Business'; break;
      case /\b(Lifetime Agency)\b/m.test(planName) : res=  'Agency'; break;
      case /\b(Lifetime Enterprise)\b/m.test(planName) : res=  'Enterprise'; break;
      case /\b(Lifetime Charter)\b/m.test(planName) : res=  'Charter Partner'; break;
      case /\b(Free Forever)\b/m.test(planName) : res=  'Forever Free'; break;
      default :  break;
    }
    return res;
  }

  stellarFeel = (name) => {
    let stellar ='';
    this.filterPlanName(name) === this.state.planClick ? stellar = 'bg--primary' : stellar = '';
    return stellar;
  }


  handlePlanSelect = (plan) => {
    this.setState({selectedPlan: plan});
  }

  clearSelectedPlan = (coupon) => {
    // const selectedPlan = this.state.servicebotPlans.filter(plan => plan.references.service_template_properties.length && plan.references.service_template_properties[0].data.value === coupon.code);
    // this.setState({ coupon: coupon, selectedPlan: selectedPlan[0]});
    this.setState({ coupon: coupon,selectedPlan:undefined});
  }

  clearCoupon = () => {
    this.setState({coupon: ''});
  }

  handlePlanChoose = (plan) =>{
    this.setState({planClick: this.filterPlanName(plan.name), selectedPlan: plan})
  }

  render() {
    const { selectedPlan, coupon, externalValue, planPeriod } = this.state;

    return (
      <div>
        {/* <Intercom appID="bstu2fsj" { ...intercomm } /> */}
        {!selectedPlan ?
          <WebsitePriceNew 
            servicebotPlans={this.state.servicebotPlans} 
            selectedPlan={this.state.selectedPlan}
            yearlyPlans={this.state.yearlyPlans}
            monthlyPlans={this.state.monthlyPlans}
            handlePlanChoose={this.handlePlanChoose}
          />
          :
          <WebsiteCheckout
            coupon={coupon}
            clearCoupon={this.clearCoupon}
            clearSelectedPlan={this.clearSelectedPlan}
            selectedPlan={selectedPlan}
          />
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.getIn(['auth', 'user'])
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(WebsitePayment);
